exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-d0155078] {\n  font-weight: 800;\n  color: black;\n}\n.form-control[data-v-d0155078]:focus {\n  border-color: #7BE855;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(123, 232, 85, 0.6);\n}\n.form-control.error[data-v-d0155078] {\n  border-color: #E84444;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(232, 68, 68, 0.6);\n}\nlegend[data-v-d0155078] {\n  padding: 0.2em 0.5em;\n  border: 1px solid #d4d8da;\n  color: black;\n  font-size: 90%;\n  background-color: #e4e4e4;\n  margin-bottom: 20px;\n}\n.mdltitle[data-v-d0155078] {\n  font-size: 18px;\n}\n.merchantfooter[data-v-d0155078] {\n  text-align: right !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0155078","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/import/import.component.scss
// module id = 1257
// module chunks = 0